import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FlexPrintDirective} from "@app/directive/flex-print/flex-print.directive";

@NgModule({
  declarations: [FlexPrintDirective],
  imports: [CommonModule],
  exports: [FlexPrintDirective],
})
export class FlexPrintModule {}
